import { removeEmptyProperties } from 'helpers/utils';

// optionValues reads a multi-select, dropping the blank options a form reset
// leaves behind; an empty selection is no filter at all.
const optionValues = options => {
  const values = (options || []).map(option => option?.value).filter(value => value !== '');
  return values.length ? values : undefined;
};

export const normalizeData = data => {
  const {
    state,
    country,
    group,
    company,
    fleet,
    status,
    status_list,
    stripe_connect_enabled,
    fraud_check,
    stripe_account_id,
    ...restData
  } = data;

  // A picked status list replaces the include-inactive checkbox; without one the
  // checkbox keeps its meaning (unticked shows active rows only).
  const statusList = optionValues(status_list);

  const newData = {
    ...restData,
    state_id: state?.value,
    country_id: country?.value,
    group_id: group?.value,
    fleet_id: fleet?.value,
    company_id: company?.value,
    status: statusList || (status ? undefined : 1),
    stripe_connect_enabled: optionValues(stripe_connect_enabled),
    fraud_check: optionValues(fraud_check),
    stripe_account_id: stripe_account_id?.trim()
  };

  return removeEmptyProperties(newData);
};
